var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMachine = function SvgMachine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2.334,
    d: "M1.722 24.618a.35.35 0 0 1 .35-.35h31.702a.35.35 0 0 1 .35.35v1.365a.35.35 0 0 1-.35.35H31.55a1.89 1.89 0 0 0-1.834-1.44H6.053c-.888 0-1.633.613-1.834 1.44H2.072a.35.35 0 0 1-.35-.35zM13.856 2.017a.35.35 0 0 1 .35-.35h19.72a.35.35 0 0 1 .35.35v18.05a.35.35 0 0 1-.35.35h-19.72a.35.35 0 0 1-.35-.35zm-12.134 0a.35.35 0 0 1 .35-.35h7.887a.35.35 0 0 1 .35.35v18.05a.35.35 0 0 1-.35.35H2.072a.35.35 0 0 1-.35-.35z"
  })));
};
export default SvgMachine;